<template>
    <!--nav-->
    <nav class="navbar navbar-default no-margin app-sidebar-nav header">
        <!-- Brand and toggle get grouped for better mobile display -->
        <div class="navbar-header fixed-brand">
            <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" id="menu-toggle">
                <span class="glyphicon glyphicon-th-large" aria-hidden="true"></span>
            </button>
            <a class="navbar-brand" href="javascript:void(0)"><img src="/static/images/logo.webp" alt="Velocity Vehicle Group"  width="161" height="32"></a>
        </div>
        <!-- navbar-header-->
        <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
            <ul class="nav navbar-nav">
                <li class="active">
                    <button class="navbar-toggle collapse in" data-toggle="collapse" id="menu-toggle-2"> 
                        <img src="/static/images/menubar.png" alt="Menu" class="menubar"  width="42" height="23">
                    </button>
                </li>
            </ul>
        </div>

        <div id="wrap" class="wrap">
            <i id="mobile-search-icon" class="fa fa-search color-0056B3" v-on:click="redirectToGlobalSearch"></i>

            <div id="search-wrapper">
                <form @submit.prevent="redirectToGlobalSearch">

                    <div class="header-search-section">
                        <input v-model="searchText" id="search" name="search" type="text" placeholder="Search..." class="header-search"> 
                        <i class="fa fa-search color-0056B3 header-search-icon" v-on:click="redirectToGlobalSearch"></i>
                    </div>

                    <div class="close-icon-section">
                        <label for="search_submit" class="search-icon fa fa-search">
                            <input id="search_submit" value="search" type="submit" class="d-none">
                        </label>
                        <i id="close-icon" class="fa fa-times color-0056B3" v-on:click="clearSearchText"></i>
                    </div>
                </form>
            </div>
        </div>

        <!--recent activity-->
        <div class="notificationCustom">
            <router-link v-bind:to="{name: 'RecentActivity'}">
                <img src="/static/images/undo-time.svg" class="recent-activity-icon" alt="Recent Activity" v-b-tooltip.hover.bottom="'Recent Activity'">
            </router-link>
        </div>

        <!--userinfo-->
        <div class="user-info">
            <div class="user-info-container">
                <div class="dropdown">
                    <button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown">
                        <div class="dropdown-user">
                            <div class="username-letter">{{loggedin_user_img}}</div>
                            <div class="dropdown-user-right">
                                <div class="username">{{formatString(loggedin_user)}} {{formatString(loggedin_user_last_name)}}</div>
                                <br/>
                                <div class="usermailid">{{email}}</div>
                            </div>
                        </div>
                    </button>
                    <div class="dropdown-menu">
                        <template v-if="user_role == 1">
                            <router-link class="dropdown-item" v-bind:to="{name: 'AddEditMenu'}">Edit Menu</router-link>
                            <router-link class="dropdown-item" v-bind:to="{name: 'UserList'}">User</router-link>
                            <router-link class="dropdown-item" v-bind:to="{name: 'ListCalendarKey'}">Calendar Keys</router-link>
                            <router-link class="dropdown-item" v-bind:to="{name: 'ListAttachmentGroup'}">Attachment Group</router-link>
                        </template>
                        <a class="dropdown-item" href="javascript:void(0)" v-on:click.prevent="logout">Logout</a>
                    </div>
                </div>
            </div>
            <a href="#" id="scroll" title="Scroll to Top" style="display: none;">Top<span></span></a>
        </div>
        <!--userinfo-->
    </nav>
    <!--nav-->
</template>

<script>
    var contex;
    import Vue from 'vue';
    import EventBus from '.././event-bus';
    import {commonMixins} from '../../mixins/commonMixins';

    export default {
        name: "Header",
        mixins: [commonMixins],
        data: () => ({
            profileColor: "",
            isShowLoggedinfields: false,
            loggedin_user_img: '',
            loggedin_user: '',
            loggedin_user_last_name: '',
            role: "",
            email: "",
            image: "/static/images/default.jpg",
            searchText: "",
            windowWidth: window.innerWidth
        }),
        beforeMount: function () {
            contex = this;
        },
        mounted: function () {
            contex = this;
            var userObj = localStorage.getItem('user_obj');
            if (userObj && userObj != null) {
                var profileColor = localStorage.getItem('profileColor');
                if (profileColor && profileColor != null) {
                    contex.profileColor = profileColor;
                } else {
                    contex.profileColor = contex.gerRandomColor();
                    localStorage.setItem("profileColor", contex.profileColor);
                }
            }
            $(window).scroll(function () {
                if ($(this).scrollTop() > 100) {
                    $('#scroll').fadeIn();
                } else {
                    $('#scroll').fadeOut();
                }
            });
            $('#scroll').click(function () {
                $("html, body").animate({
                    scrollTop: 0
                }, 600);
                return false;
            });

            window.addEventListener('resize', contex.handleWindowSizeChange);
        },
        beforeDestroy() {
            window.removeEventListener('resize', contex.handleWindowSizeChange); // Remove the event listener when the component is destroyed
        },
        methods: {
            redirectToGlobalSearch : function() {
                var location = window.location.pathname;

                contex.handleWindowSizeChange();
                contex.searchAlertBasedOnLen();

                if (contex.searchText.length > 2) {
                    if (location === "/globalsearch") {
                        contex.$router.replace({ name: 'GlobalSearchView', params: {searchText: contex.searchText }}).catch(()=>{});
                    } else {
                        contex.$router.push({ name: 'GlobalSearchView', params: {searchText: contex.searchText }}).catch(()=>{});
                    }
                }
            },
            logout: function () {
                var current_build = window.localStorage.getItem("build_version");
                //clear all local storage
                localStorage.clear();
                localStorage.setItem("build_version", current_build);

                // Auto-logout Current Project From SSO
                window.location.href = process.env.VUE_APP_SSO_ROOT_URL + "/logout?redirect_url=" + process.env.VUE_APP_FRONT_ROOT_URL + '&slug=' + process.env.VUE_APP_PROJECT_SLUG;
            },
            formatString: function (data) {
                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp.toUpperCase();
            },
            /**
             * Clear the search text by setting it to an empty string.
             */
            clearSearchText: function() {
                contex.searchText = '';
            },
            /**
             * Update the window width property with new window dimensions and handle mobile-specific UI behavior.
             * If the window width is less than or equal to 944 pixels, set up event listeners to show/hide 
             * the search wrapper when the mobile search icon or close icon is clicked.
             */
            handleWindowSizeChange() {
                contex.windowWidth = window.innerWidth;

                if (contex.windowWidth <= 944) {
                    $(document).ready(function(){
                        $("#mobile-search-icon").click(function(){
                            $("#search-wrapper").show();
                        });
                        $("#close-icon").click(function(){
                            $("#search-wrapper").hide();
                        });
                    });
                }
            },
            /**
             * Display a search alert based on the length of the search text and the window width.
             * 
             * If the window width is <= 944 pixels and the search text is <= 2 characters, 
             * display an informational alert to prompt the user to enter more characters. 
             * 
             * Otherwise, display the alert if the search text length <= 2 characters.
             */
            searchAlertBasedOnLen() {
                if (contex.windowWidth <= 944) { // Mobile View
                    if (contex.searchText && contex.searchText.length <= 2) {
                        contex.$swal("","Please search more than 2 characters", "info");
                    } 
                } else { // Desktop View
                    if (contex.searchText.length <= 2) {
                        contex.$swal("","Please search more than 2 characters", "info");
                    }
                }
            }
        }
    };
    EventBus.$on('on-globalsearch', function () {
        contex.searchText = "";
    });
    EventBus.$on('logged-in', function (isLogin, name, lastName, email,username) {
        contex.isShowLoggedinfields = isLogin;
        contex.loggedin_user = name.trim();
        contex.loggedin_user_last_name = lastName.trim();
        contex.loggedin_user_img = (contex.loggedin_user.charAt(0) + contex.loggedin_user_last_name.charAt(0)).toUpperCase();
        contex.email = email;
        if (contex.loggedin_user_img == "") {
            contex.loggedin_user_img = (contex.email.charAt(0) + contex.email.charAt(1)).toUpperCase();
        }
    });
</script>